import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=31a8cdba&lang=scss&scoped=true"

import exportComponent from "/Users/lisha/Desktop/project/jierong/weidiansi-mobilemall3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31a8cdba"]])

export default __exports__